/*
 * Public API Surface of ui-components
 */

// Modules
export * from './lib/primeng.module';
export * from './lib/ui-components.module';

// Ui Components
export * from './lib/button/sw-button.component';
export * from './lib/page-head/sw-page-head.component';
export * from './lib/confirmation-dialog/confirmation-dialog.component';
export * from './lib/confirm-dialog/confirm-dialog.component';

// Models
export * from './lib/model/dialog.model';
